import type { DocumentFillerRun, DocumentFillPreview } from "@/schema"
import { useMutation } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { createDocumentFill, CreateDocumentFillParams, previewDocumentFill, PreviewDocumentFillParams } from "./api"

export function usePreviewDocumentFill(householdId: string) {
  const getContext = useApiContext()

  return useMutation<DocumentFillPreview, Error, PreviewDocumentFillParams>({
    mutationFn: async (params) => {
      const context = await getContext()
      if (!context) throw new Error("No API context")
      return previewDocumentFill(context, householdId, params)
    },
  })
}

export function useCreateDocumentFill(householdId: string) {
  const getContext = useApiContext()

  return useMutation<DocumentFillerRun, Error, CreateDocumentFillParams>({
    mutationFn: async (params) => {
      const context = await getContext()
      if (!context) throw new Error("No API context")
      return createDocumentFill(context, householdId, params)
    },
  })
}
